'use client'

import Link from 'next/link'

export default function MembershipBanner() {
  return (
    <div className="relative rounded-xl overflow-hidden mb-10">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 via-purple-600/20 to-pink-600/20" />
      <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 px-5 py-4 border border-gray-700/50 rounded-xl">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">
            Join AI Builder Club for courses, community, and weekly workshops.
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            30-day money-back guarantee. $37/mo.
          </p>
        </div>
        <Link
          href="/pricing?utm_source=blog&utm_medium=banner&utm_campaign=article_top"
          className="shrink-0 bg-white text-black font-semibold text-xs px-4 py-2 rounded-full hover:bg-gray-200 transition-colors"
        >
          See Plans →
        </Link>
      </div>
    </div>
  )
}
